/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isBlank } from '@ember/utils';
import Component from '@glimmer/component';
import DeviceModel from 'cio/models/device';
import { inject as service } from '@ember/service';
import DevicesService from 'cio/services/devices';

/* eslint-disable spellcheck/spell-checker */
const KNOWN_DEVICE_MODELS: Record<string, string> = {
  'Pixel 2 XL': new URL('cio/assets/images/phone/models/google-pixel-2-xl.png', import.meta.url).toString(),
  'Pixel 2': new URL('cio/assets/images/phone/models/google-pixel-2.png', import.meta.url).toString(),
  'Pixel 4': new URL('cio/assets/images/phone/models/google-pixel-4.png', import.meta.url).toString(),
  'Pixel 4a': new URL('cio/assets/images/phone/models/google-pixel-4a.png', import.meta.url).toString(),
  'Pixel 5': new URL('cio/assets/images/phone/models/google-pixel-5.png', import.meta.url).toString(),
  'Pixel 6': new URL('cio/assets/images/phone/models/google-pixel-6.png', import.meta.url).toString(),
  'Google Pixel 2 XL': new URL('cio/assets/images/phone/models/google-pixel-2-xl.png', import.meta.url).toString(),
  'Google Pixel 2': new URL('cio/assets/images/phone/models/google-pixel-2.png', import.meta.url).toString(),
  'Google Pixel 4': new URL('cio/assets/images/phone/models/google-pixel-4.png', import.meta.url).toString(),
  'Google Pixel 4a': new URL('cio/assets/images/phone/models/google-pixel-4a.png', import.meta.url).toString(),
  'Google Pixel 5': new URL('cio/assets/images/phone/models/google-pixel-5.png', import.meta.url).toString(),
  'Google Pixel 6': new URL('cio/assets/images/phone/models/google-pixel-6.png', import.meta.url).toString(),
  'Google Pixel 7': new URL('cio/assets/images/phone/models/google-pixel-7.png', import.meta.url).toString(),
  'Google Pixel 7 Pro': new URL('cio/assets/images/phone/models/google-pixel-7-pro.png', import.meta.url).toString(),
  'iPhone 11 Pro': new URL('cio/assets/images/phone/models/iphone-11-pro.png', import.meta.url).toString(),
  'iPhone 12 mini': new URL('cio/assets/images/phone/models/iphone-12-mini.png', import.meta.url).toString(),
  'iPhone 12 Pro Max': new URL('cio/assets/images/phone/models/iphone-12-pro-max.png', import.meta.url).toString(),
  'iPhone 12 Pro': new URL('cio/assets/images/phone/models/iphone-12-pro.png', import.meta.url).toString(),
  'iPhone 13': new URL('cio/assets/images/phone/models/iphone-13.png', import.meta.url).toString(),
  'iPhone SE (1st generation)': new URL('cio/assets/images/phone/models/iphone-se.png', import.meta.url).toString(),
  'iPhone SE (2nd generation)': new URL('cio/assets/images/phone/models/iphone-se.png', import.meta.url).toString(),
  'iPhone SE (3rd generation)': new URL('cio/assets/images/phone/models/iphone-se.png', import.meta.url).toString(),
  'OnePlus 7T Pro 5G': new URL('cio/assets/images/phone/models/oneplus-7t-pro-5g.png', import.meta.url).toString(),
  'OnePlus 8 Pro': new URL('cio/assets/images/phone/models/oneplus-8-pro.png', import.meta.url).toString(),
  'Galaxy A50': new URL('cio/assets/images/phone/models/samsung-galaxy-a50.png', import.meta.url).toString(),
  'Galaxy Note20 5G': new URL(
    'cio/assets/images/phone/models/samsung-galaxy-note20-5g.png',
    import.meta.url,
  ).toString(),
  'Galaxy Note20 Ultra 5G': new URL(
    'cio/assets/images/phone/models/samsung-galaxy-note20-ultra-5g.png',
    import.meta.url,
  ).toString(),
  'Galaxy S20 5G': new URL('cio/assets/images/phone/models/samsung-galaxy-s20-5g.png', import.meta.url).toString(),
  'Xperia 1 II': new URL('cio/assets/images/phone/models/sony-xperia-1-ii.png', import.meta.url).toString(),
};
const PLATFORM_DEFAULTS: Record<string, string> = {
  ios: new URL('cio/assets/images/phone/models/default-ios.png', import.meta.url).toString(),
  android: new URL('cio/assets/images/phone/models/default-android.png', import.meta.url).toString(),
};
/* eslint-enable spellcheck/spell-checker */

interface DeviceImageArgs {
  device: DeviceModel;
}

export default class DeviceImage extends Component<DeviceImageArgs> {
  @service devices!: DevicesService;

  constructor(owner: unknown, args: DeviceImageArgs) {
    super(owner, args);

    this.devices.load.perform();
  }

  get deviceImage() {
    let { deviceModel, platform } = this.args.device;
    return this.getModelImage(deviceModel) ?? this.getDefaultImage(platform);
  }

  private getModelImage(model: string) {
    if (isBlank(model)) {
      return null;
    }
    let marketingName = this.devices.getMarketingName(model);
    // multiple models can have the same marketing name, due to different variants in storage, RAM etc.
    return KNOWN_DEVICE_MODELS[marketingName];
  }

  private getDefaultImage(platform: string) {
    return PLATFORM_DEFAULTS[platform];
  }
}
